// extracted by mini-css-extract-plugin
module.exports = {"ScreenDivisionTop":"CardListStatsScreen_ScreenDivisionTop__3lymf","ScreenDivisionBottom":"CardListStatsScreen_ScreenDivisionBottom__33S57"};